import API from './API'

const SSE_URL = (API.isProd()) ? "https://sse.homyhub.com:8889" : "https://devapp.homyhub.com:8889"
const MAX_ERROR_RESTARTS = 3

export default class SSE
{
    static instance = null
    
    access_token    = null
    eventSource     = null
    doorListeners   = []
    doorIdsArr      = []
    numRestarts     = 0
    isClosing       = false
    
    
    constructor()
    {
        this.access_token = API.getInstance().getToken()
    }
    static getInstance()
    {
        if (this.instance == null)
            this.instance = new SSE()

        return this.instance
    }
    
    whenReady()
    {
        let whenReadyTimer = null
        let timeoutTimer = null
        
        return new Promise((resolve) =>
        {
            whenReadyTimer = setInterval(() =>
            {
                if (this.doorListeners.length > 0)
                {
                    if (whenReadyTimer != null)
                    {
                        clearInterval(whenReadyTimer)
                        whenReadyTimer = null
                    }
                    if (timeoutTimer != null)
                    {
                        clearTimeout(timeoutTimer)
                        timeoutTimer = null
                    }
                    
                    resolve()
                }
            }, 1000)
            
            timeoutTimer = setTimeout(() =>
            {
                if (whenReadyTimer != null)
                {
                    clearInterval(whenReadyTimer)
                    whenReadyTimer = null
                }
            }, 15000)
        })
    }
    
    getLiveEvents(doorIdsArr)
    {
        this.access_token = API.getInstance().getToken()
        
        if (this.access_token != null &&
            doorIdsArr != null &&
            doorIdsArr.length > 0)
        {
            this.doorIdsArr = doorIdsArr
            this.eventSource = new EventSource(`${SSE_URL}?doorId=${doorIdsArr.join()}&access_token=${this.access_token}`)
            
            this.eventSource.onopen = (event) =>
            {
                //console.log('Opened SSE', event)
                
                doorIdsArr.forEach(doorId =>
                {
                    if (!this.doorListeners.some(dl => dl.doorId === doorId))
                        this.doorListeners.push({ doorId, listeners: [] })
                })
            }
            
            this.eventSource.onmessage = (event) =>
            {
                //console.log('Message SSE', event)
                this.onDataReceived(event)
            }
            this.eventSource.addEventListener('data', event =>
            {
                //console.log('Message SSE', event)
                this.onDataReceived(event)
            })
            
            this.eventSource.onerror = (event) =>
            {
                console.log('Error SSE', event)
                this.onError(event)
            }
            this.eventSource.addEventListener('appError', (event) =>
            {
                this.onAppError(event)
            })
        }
    }
    subscribeToDoorEvents(doorId, callFunction)
    {
        let doorListenersObj = this.getDoorListenersObj(doorId)
        if (doorListenersObj)
            doorListenersObj.listeners.push(callFunction)
    }
    unsubscribeToDoorEvents(doorId, callFunction)
    {
        let doorListenersObj = this.getDoorListenersObj(doorId)
        
        if (doorListenersObj == null)
            return
        
        let index = doorListenersObj.listeners.indexOf(callFunction)
        if (index !== -1)
            doorListenersObj.listeners.splice(index, 1)
    }
    
    onDataReceived(event)
    {
        //console.log(`SSE Data`, event.data, (new Date()).toISOString())
        
        let data = JSON.parse(event.data)
        if (data.actionType != null && data.actionType === "TRIGGER_DOOR")
            data.user = data.userInfo
        else if (data.data != null)
            data = data.data
        
        let doorId = null
        if (data.doorId != null)
            doorId = data.doorId
        else if (data.actuatorId != null)
            doorId = API.getInstance().getDoorIdFromActuatorId(data.actuatorId)
        else if (data.sensorId != null)
            doorId = API.getInstance().getDoorIdFromSensorId(data.sensorId)
        
        if (doorId == null)
            return
        
        //console.log(`For doorId: ${doorId}`)
        let doorListenersObj = this.getDoorListenersObj(doorId)
        if (doorListenersObj != null)
            doorListenersObj.listeners.forEach((callFunction) => callFunction(data))
    }
    onError(event)
    {
        console.log(`Error SSE`, event)
        
        if (this.numRestarts < MAX_ERROR_RESTARTS)
        {
            setTimeout(() =>
            {
                this.restartEventSource()
            }, 1000)
        }
        else
            SSE.closeLiveEvents()
    }
    onAppError(event)
    {
        console.log(`App Error SSE`, event)
    }
    
    getDoorListenersObj(doorId)
    {
        return this.doorListeners.find(doorListenersObj => doorListenersObj.doorId === doorId)
    }
    
    restartEventSource()
    {
        console.log('restartEventSource')
        
        if (this.isClosing)
            return
        
        this.isClosing = true
        this.numRestarts++
        
        //if (this.eventSource != null)
            //this.eventSource.removeAllListeners()
        
        setTimeout(() =>
        {
            if (this.eventSource != null)
                this.eventSource.close()
            
            setTimeout(() =>
            {
                this.isClosing = false
                this.getLiveEvents(this.doorIdsArr)
            }, 250)
        }, 250)
    }
    static closeLiveEvents()
    {
        if (this.instance == null || this.instance.eventSource == null)
            return
            
        //this.instance.eventSource.removeAllListeners()
        this.instance.eventSource.close()
        
        console.log('closeLiveEvents')
    }
}